/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { makeAPI } from "@/frameworks/core/API";
import GroupService from "./api";

export default function withGroupUser(events: API.Events) {
	return {
		user: {
			leave: makeAPI<WebServices.GroupUser.Leave.Response>(GroupService.groupUser.leave("user:leave", events)),
			cancelLeave: makeAPI<WebServices.GroupUser.CancelLeave.Response>(
				GroupService.groupUser.cancelLeave("user:cancelleave", events)
			),
			delete: makeAPI<WebServices.GroupUser.Delete.Response>(
				GroupService.groupUser.deleteMember("user:delete", events)
			),
			deleteCheck: makeAPI<WebServices.GroupUser.CheckLeave.Response>(
				GroupService.groupUser.isLeaveAvailable("user:deleteCheck", events)
			),
			list: makeAPI<WebServices.GroupUser.List.Response>(GroupService.groupUser.list("user:list", events)),
			leaveRequestList: makeAPI<WebServices.GroupUser.LeaveRequestList.Response>(
				GroupService.groupUser.leaveRequestList("user:leaveRequestList", events)
			),
			process: makeAPI<WebServices.GroupUser.Process.Response>(
				GroupService.groupUser.process("user:process", events)
			),
			appointment: makeAPI<WebServices.GroupUser.Appointment.Response>(
				GroupService.groupUser.appointment("user:appointment", events)
			),
			joinStatus: makeAPI<WebServices.GroupUser.JoinStatus.Response>(
				GroupService.groupUser.joinStatus("user:joinStatus", events)
			)
		}
	};
}
